import { Pipe, PipeTransform } from '@angular/core';
import { indexOf as _indexOf} from 'lodash-es';
@Pipe({
  name: 'showSelectedTableCategory'
})
export class ShowSelectedTableCategoryPipe implements PipeTransform {
  transform(tableCategory: any, selectedItemsCategoryMap: any, fieldName) {
    const tableIndex =  _indexOf(selectedItemsCategoryMap[tableCategory], fieldName);
    if (tableIndex === 0 ) {
      return tableCategory;
    } else {
      return '';
    }
  }

}
